const resources = {
    beautyMatchesPopupText: 'A Beauty Match is someone who shares your Beauty Traits. For the best experience with this feature, please make sure you’ve added all your Beauty Traits in',
    beautyMatchesPopupLink: 'Community profile',
    beautyMatchesPopupTextUpdated: 'A Beauty Match is someone who shares the same beauty traits as you (skin tone or hair concerns, etc.). For the best experience with this feature, please add your info to your',
    beautyMatchesPopupLinkUpdated: 'Beauty Preferences'
};

module.exports = function getResource(label) {
    return resources[label];
};
